// extracted by mini-css-extract-plugin
export default {"claimsSummaryShortfall":"_3mmfn7Fy3ACeJi5TKDL73F"};